const Reflux = require("reflux");
const WonDealsActions = require("../actions/won-deals-actions");

const WonDealsStore = Reflux.createStore({
  state: {
    loading: true,
    failed: false,
    data: {
      count: 0,
      countDelta: 0,
      amount: 0,
      amountDelta: 0,
      averageDuration: 0,
      averageDurationDelta: 0,
      averageAmount: 0,
      averageAmountDelta: 0,
      history: []
    }
  },

  init: function() {
    this.listenTo(WonDealsActions.fetchData, this.onFetchStarted);
    this.listenTo(WonDealsActions.fetchData.completed, this.onFetchCompleted);
    this.listenTo(WonDealsActions.fetchData.failed, this.onFetchFailed);

    this.state = this.getInitialState();
  },

  getInitialState: function() {
    return this.state;
  },

  onFetchStarted: function() {
    this.state = {
      loading: true,
      failed: false
    };

    this.trigger(this.state);
  },

  onFetchCompleted: function(data) {
    this.state = {
      loading: false,
      data: {
        count: data.count.value,
        countDelta: data.count.delta,
        amount: data.total_amount.value,
        amountDelta: data.total_amount.delta,
        averageDuration: data.avg_duration.value,
        averageDurationDelta: data.avg_duration.delta,
        averageAmount: data.avg_amount.value,
        averageAmountDelta: data.avg_amount.delta,
        history: data.history
      }
    };

    this.trigger(this.state);
  },

  onFetchFailed: function(error) {
    this.state = {
      loading: false,
      failed: true
    };

    this.trigger(this.state);
  }
});

module.exports = WonDealsStore;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/stores/won-deals-store.js